module.exports = __webpack_public_path__ + "img/medicine.ddc581f9.png";